const encodePrefix = "__sden-v1";
const regex = new RegExp(`^${encodePrefix}:(\\w+)(?::(.*))?$`);
function encode(obj) {
  if (obj == null)
    return `${encodePrefix}:null`;
  if (typeof obj === "string")
    return `${encodePrefix}:s:${obj}`;
  if (typeof obj === "number")
    return `${encodePrefix}:n:${obj}`;
  if (typeof obj === "boolean")
    return `${encodePrefix}:bl:${obj ? "t" : "f"}`;
  return `${encodePrefix}:o:${JSON.stringify(obj)}`;
}
function decode(str) {
  if (str == null)
    return null;
  const match = regex.exec(str);
  if (match == null) {
    console.warn(`Invalid string: ${str}`);
    return str;
  }
  const type = match[1];
  const value = match[2];
  if (type === "null")
    return null;
  if (type === "s")
    return value;
  if (type === "n")
    return Number(value);
  if (type === "bl")
    return value === "t";
  if (type === "o")
    return JSON.parse(value);
  throw new Error(`Invalid type: ${type}`);
}
export {
  decode,
  encode
};
